module.exports = __webpack_public_path__ + "static/media/rainfall_3.0df63dd1.png";